import React from 'react';
import { useApp } from '../../context/AppContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';

function LegalModal() {
  const { state, actions } = useApp();

  const handleClose = () => {
    actions.setShowLegalModal(false);
    actions.setLegalContent('');
    actions.setLegalTitle('');
  };

  if (!state.showLegalModal) {
    return null;
  }

  return (
    <Dialog open={state.showLegalModal} onOpenChange={handleClose}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">
            {state.legalTitle}
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4">
          <div 
            className="prose prose-sm max-w-none text-gray-700 leading-relaxed"
            dangerouslySetInnerHTML={{ __html: state.legalContent }}
          />
        </div>

        <div className="mt-6 pt-4 border-t border-gray-200">
          <div className="flex justify-end">
            <Button onClick={handleClose} className="bg-blue-600 hover:bg-blue-700">
              Fermer
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default LegalModal;